<!--
 * @Author: zjx
 * @Date: 2023-03-14 15:05:22
 * @LastEditors: 1314520zjX! 1833496831@qq.com
 * @LastEditTime: 2023-03-25 17:08:49
 * @FilePath: \onemap-web\src\components\CultivatedLandComponent\Table.vue
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <Row>
    <Col span="24">
      <Table :columns="columns" :data="TableData" :maxHeight="500"></Table>
    </Col>
    <Row>
      <Col span="24">
        <Page
          :total="TableTotal"
          show-elevator
          show-sizer
          class="page"
          @on-change="changeNumber"
          @on-page-size-change="changeSize"
        />
      </Col>
    </Row>
  </Row>
</template>

<script>
import customConfig from 'customConfig';
import appConfig from 'appConfig';
export default {
  props: {
    TableColumns: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    TableData: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    TableTotal: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      columns: [],
      layerQueryData: {
        maxFeatures: 10,
        startIndex: 0,
      },
      title: '',
      wkt: null,
    };
  },
  methods: {
    /**
     * 获取父级传来的参数 给最后一个加入一个render对象查看按钮
     * @date 2023-03-14
     * @returns {any}
     */
    initTableColumns() {
      const operationColumn = {
        title: '操作',
        align: 'center',
        render: (h, params) => {
          return h(
            'Button',
            {
              props: {
                type: 'primary',
                size: 'small',
              },
              style: {
                marginRight: '5px',
              },
              on: {
                click: () => {
                  this.title = params.row.hasOwnProperty('fieldName')
                    ? params.row.fieldName
                    : (this.title = params.row.title);
                  this.handlerDetails(params.row);
                  this.layerQueryData.startIndex = 0;
                  this.$bus.emit('CultivatedSetTitle', this.title);
                },
              },
            },
            '查看'
          );
        },
      };
      this.columns = [...this.TableColumns, operationColumn];
    },
    /**
     * @description: 获取customConfig的参数进行传参 拿到右边的表格详情
     * @Author: zjx
     * @Date: 2023-03-21 19:54:46
     * @param {*} const
     * @param {*} this
     * @param {*} this
     * @param {*} this
     * @return {*}
     */
    async handlerDetails() {
      const { layerInfo } = customConfig.themeService[this.$route.query.customId];
      this.layerQueryData.where = `${layerInfo.wfs.keyFilds}='${this.title}'`;
      this.layerQueryData.CqlFilter =
        this.wkt != null
          ? `${layerInfo.wfs.keyFilds}='${this.title}' and INTERSECTS(the_geom,${this.wkt})`
          : this.title === ''
          ? ''
          : `${layerInfo.wfs.keyFilds}='${this.title}'`;
      this.layerQueryData.TypeName = layerInfo.layername;
      this.layerQueryData.SrsName = appConfig.map.proj;
      var pjsonResult = await this.publicMethod.geoServerQueryPost(
        layerInfo.url,
        this.layerQueryData,
        this.$olmap
      ); //通用查询方法
      // 获取geoserver的全部地图数据 这一块是获取点击查看后有一个过滤属性的
      let mapData = JSON.parse(JSON.stringify(this.layerQueryData));
      if (pjsonResult.featureArr && pjsonResult.featureArr.length > 0) {
        if (this.wkt != null) {
          pjsonResult.wkt = this.wkt;
        }
        this.$bus.emit('CultivatedLand', { data: pjsonResult, type: 'zoom' });
        this.wkt = null;
      }
    },
    async initMap() {
      const { layerInfo } = customConfig.themeService[this.$route.query.customId];
      this.layerQueryData.where = '';
      this.layerQueryData.CqlFilter = '';
      this.layerQueryData.TypeName = layerInfo.layername;
      this.layerQueryData.SrsName = appConfig.map.proj;
      this.layerQueryData.sldName = layerInfo.sldName;
      let mapData = JSON.parse(JSON.stringify(this.layerQueryData));
      var layerObj = {};
      mapData.id = '_layertree_:Tyson';
      mapData.url = layerInfo.url;
      mapData.layername = layerInfo.layername;
      var MappjsonResult = await this.publicMethod.createGeoServerWMS(this.$olmap, mapData, 701);
      layerObj.MappjsonResult = MappjsonResult;
      layerObj.mapData = mapData;
      this.$bus.emit('CultivatedMap', { data: layerObj, type: 'add' });
    },

    changeNumber(v) {
      this.$emit('changeNumber', v);
    },
    changeSize(v) {
      this.$emit('changeSize', v);
    },
  },
  watch: {
    TableColumns: {
      handler() {
        this.initTableColumns();
        this.initMap();
      },
      deep: true,
    },
  },
  created() {
    this.initTableColumns();
  },
  mounted() {
    this.$bus.off('CultivatedLandTablePageNumber');
    this.$bus.on('CultivatedLandTablePageNumber', v => {
      this.layerQueryData.startIndex = (v.index - 1) * 10;
      if (v.type === 'remove') return;
      this.handlerDetails();
    });
    this.$bus.off('CultivatedLandWkt');
    this.$bus.on('CultivatedLandWkt', val => {
      this.wkt = val;
      this.handlerDetails();
    });
    this.initMap();
  },
};
</script>

<style lang="less" scoped>
.page {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/CultivatedLandComponent/Table.vue